export const props = {
    MuiTextField: {
        variant: 'outlined',
        label: null,
        fullWidth: true,

        InputLabelProps: {
            disableAnimation: true,
            shrink: true
        }
    }
};
